import { Flex, HStack, Image, Link } from '@chakra-ui/react';
import { EXTERNAL_LINK } from '@ui/config/externalLinks';
import { isFeatureEnabled } from '@ui/config/featureFlags';
import { paths } from '@ui/config/paths';
import { MAX_WIDTH, TOP_NAV_HEIGHT } from '@ui/config/ui';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import { NextLinkWithIntl } from '@ui/locales/browserSSG';
import React from 'react';

import { GraduationBanner } from './GraduationBanner';
import { WalletNavItem } from './WalletNavItem';

export const TopNavbar = () => {
  const chainLayer = useGlobalChainLayer();
  const isAlphaLogoEnabled = isFeatureEnabled('alphaLogo');

  return (
    <Flex flexDir="column" position="sticky" top="0" left="0" zIndex="docked">
      <Flex
        px="20px"
        h={`${TOP_NAV_HEIGHT}px`}
        align="center"
        justifyContent="center"
        bgGradient="linear-gradient(180deg, #FFF9ED 0%, #FFC700 100%)"
        borderBottomWidth="2px"
        borderColor="text.default"
      >
        <HStack maxW={`${MAX_WIDTH}px`} justify="space-between" flex="1 1 auto">
          <NextLinkWithIntl href={paths.home}>
            <Image
              w="115px"
              h="32px"
              src={
                isAlphaLogoEnabled
                  ? '/images/logo-dark-alpha.svg'
                  : '/images/logo-dark.svg'
              }
              alt="AgentFun AI"
            />
          </NextLinkWithIntl>
          <HStack>
            <Link href={EXTERNAL_LINK.swapAgentFun(chainLayer)} target="_blank">
              <Image
                src="/images/buy-agentfun.png"
                boxSize="40px"
                alt="buy AIFun token"
              />
            </Link>
            <WalletNavItem />
          </HStack>
        </HStack>
      </Flex>
      <GraduationBanner />
    </Flex>
  );
};
